module.exports = __webpack_public_path__ + "static/video4-c2ddccdf28bc5e66aa64c060db1016ab.mp4";